export default __webpack_public_path__ + "static/media/slide3.551286d1.jpg";